import type * as lazyIndex from './lazyIndex';
import { LazyImport, LazyModule } from 'owa-bundling';

export const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "MailRibbonSections"*/ './lazyIndex'),
    { name: 'MailRibbonSections' }
);

export const lazyGetAssignPolicySections: LazyImport<
    typeof lazyIndex.getAssignPolicySections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getAssignPolicySections);
export const lazyGetBlockSections: LazyImport<
    typeof lazyIndex.getBlockSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getBlockSections);
export const lazyGetCategorizeSections: LazyImport<
    typeof lazyIndex.getCategorizeSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getCategorizeSections);
export const lazyClearPreCheckedCategories: LazyImport<
    typeof lazyIndex.clearPreCheckedCategories,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.clearPreCheckedCategories);
export const lazyGetChangeNoteColorSections: LazyImport<
    typeof lazyIndex.getChangeNoteColorSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getChangeNoteColorSections);
export const lazyGetConversationsSections: LazyImport<
    typeof lazyIndex.getConversationsSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getConversationsSections);
export const lazyGetDeleteSections: LazyImport<
    typeof lazyIndex.getDeleteSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getDeleteSections);
export const lazyGetDensitySections: LazyImport<
    typeof lazyIndex.getDensitySections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getDensitySections);
export const lazyGetFlagUnflagSections: LazyImport<
    typeof lazyIndex.getFlagUnflagSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getFlagUnflagSections);
export const lazyGetFolderMenuOptionsSections: LazyImport<
    typeof lazyIndex.getFolderMenuOptionsSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getFolderMenuOptionsSections);
export const lazyGetForwardSections: LazyImport<
    typeof lazyIndex.getForwardSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getForwardSections);
export const lazyGetLayoutSections: LazyImport<
    typeof lazyIndex.getLayoutSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getLayoutSections);
export const lazyGetMessagePreviewSections: LazyImport<
    typeof lazyIndex.getMessagePreviewSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getMessagePreviewSections);
export const lazyGetMessagesSections: LazyImport<
    typeof lazyIndex.getMessagesSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getMessagesSections);
export const lazyGetMoveToSections: LazyImport<
    typeof lazyIndex.getMoveToSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getMoveToSections);
export const lazyGetCopyToSections: LazyImport<
    typeof lazyIndex.getCopyToSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getCopyToSections);
export const lazyGetNewGroupSections: LazyImport<
    typeof lazyIndex.getNewGroupSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getNewGroupSections);
export const lazyGetQuickStepsSections: LazyImport<
    typeof lazyIndex.getQuickStepsSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getQuickStepsSections);
export const lazyGetReadingPaneOptionsSections: LazyImport<
    typeof lazyIndex.getReadingPaneOptionsSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getReadingPaneOptionsSections);
export const lazyGetReportSections: LazyImport<
    typeof lazyIndex.getReportSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getReportSections);
export const lazyGetRespondSections: LazyImport<
    typeof lazyIndex.getRespondSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getRespondSections);
export const lazyGetRulesSections: LazyImport<
    typeof lazyIndex.getRulesSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getRulesSections);
export const lazyGetSnoozeSections: LazyImport<
    typeof lazyIndex.getSnoozeSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getSnoozeSections);
export const lazyGetViewGroupsSections: LazyImport<
    typeof lazyIndex.getViewGroupsSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getViewGroupsSections);
export const lazyGetRibbonModeMenuSections: LazyImport<
    typeof lazyIndex.getRibbonModeMenuOptionsSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getRibbonModeMenuOptionsSections);
export const lazyGetCopilotReplyWithMeetingSections: LazyImport<
    typeof lazyIndex.getCopilotReplyWithMeetingSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getCopilotReplyWithMeetingSections);
export const lazyGetTeamsChatAroundEmailSections: LazyImport<
    typeof lazyIndex.getTeamsChatAroundEmailSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getTeamsChatAroundEmailSections);
export const lazyGetMyDayMenuSections: LazyImport<
    typeof lazyIndex.getMyDayMenuSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getMyDayMenuSections);
